import { api } from './api';

export const locationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLocation: build.query({
      query: (id) => ({
        url: `location/${id}`,
      }),
      providesTags: (_result, _err, id) => [{ type: 'Locations', id }],
    }),
    updateLocation: build.mutation({
      query: ({id, form}) => ({
        url: `location/${id}`,
        method: 'PUT',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => [{ type: 'Locations', id: result.data.model.ID }],
    }),
    createLocation: build.mutation({
      query: (form) => ({
        url: 'location',
        method: 'POST',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Locations', id: 'LIST' }],
    }),
    deleteLocation: build.mutation({
      query: (id) => ({
        url: `location/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Locations', id: 'LIST' }],
    }),
    getLocationTypes: build.query({
      query: () => ({
        url: 'settings/location_types',
        method: 'GET',
      }),
      providesTags: ['LocationTypes'],
    }),
  }),
})

export const {
  useGetLocationQuery,
  useGetLocationTypesQuery,
  useLazyGetLocationQuery,
  useUpdateLocationMutation,
  useCreateLocationMutation,
  useDeleteLocationMutation,
} = locationApi;

